import React from 'react'
// import classes from './Loading.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Button, WhiteSpace, WingBlank } from 'antd-mobile'
import { Skeleton } from 'antd'

function Loading(props) {
  const handleRetry = () => {
    props.retry()
  }
  if (props.error) {
    return (
      <WingBlank className='text-center'>
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <h3>
          <FormattedMessage {...messages.errorTitle} />
        </h3>
        <p>
          <FormattedMessage {...messages.errorDes} />
        </p>
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <Button type='primary' onClick={handleRetry}>
          <b>
            <FormattedMessage {...messages.btn} />
          </b>
        </Button>
      </WingBlank>
    )
  } else if (props.timedOut) {
    return (
      <WingBlank className='text-center'>
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <h3><FormattedMessage {...messages.timeoutTitle} /></h3>
        <p><FormattedMessage {...messages.timeoutDes} /></p>
        <WhiteSpace size='xl' />
        <WhiteSpace size='xl' />
        <Button type='primary' onClick={handleRetry}>
          <b><FormattedMessage {...messages.btn} /></b>
        </Button>
      </WingBlank>
    )
  } else if (props.pastDelay) {
    return <Skeleton active />
  } else {
    return null
  }
}

export default Loading
